import '../CreateEditDialog.scss';

import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';
import { FC, useMemo } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { getDays } from '../CreateEditDialog.functions';

interface OpeningHoursEditorProps {
  dayIndex: number;
}

const OpeningHoursEditor: FC<OpeningHoursEditorProps> = ({ dayIndex }) => {
  const { t } = useTranslation();
  const days = useMemo(() => getDays(t), [t]);

  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: `workingHours.${dayIndex}.openingHours`,
  });

  return (
    <div>
      <div className="day-header">
        <label className="time-label">
          {days.find((d) => d.dayOfWeek === days[dayIndex].dayOfWeek)?.label ||
            ''}
        </label>
        <Button
          type="button"
          label="+"
          className="add-interval-btn"
          onClick={() => append({ from: '00:00', to: '00:00' })}
        />
      </div>

      {fields.map((field, idx) => (
        <div key={field.id} className="time-row-working">
          <Controller
            name={`workingHours.${dayIndex}.openingHours.${idx}.from`}
            control={control}
            render={({ field }) => (
              <InputMask
                {...field}
                mask="99:99"
                placeholder="HH:MM"
                className="time-input"
              />
            )}
          />

          <Controller
            name={`workingHours.${dayIndex}.openingHours.${idx}.to`}
            control={control}
            render={({ field }) => (
              <InputMask
                {...field}
                mask="99:99"
                placeholder="HH:MM"
                className="time-input"
              />
            )}
          />

          {fields.length > 1 && (
            <Button
              type="button"
              label="×"
              className="remove-interval-btn p-button-danger"
              onClick={() => remove(idx)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default OpeningHoursEditor;
